import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { type MatchmakerFriend } from '../lib/friendCriteria';

export type MatchmakerFriendStore = {
  friend: MatchmakerFriend | null;
  setFriend: (friend: MatchmakerFriend) => void;
  clearFriendCity: () => void;
};

/** «Кого сосватаем?», kept on this device only. */
export const useMatchmakerFriendStore = create<MatchmakerFriendStore>()(
  persist(
    (set) => ({
      friend: null,
      setFriend: (friend) => set({ friend }),
      clearFriendCity: () =>
        set(({ friend }) =>
          friend ? { friend: { ...friend, city: '' } } : {},
        ),
    }),
    {
      name: 'matchmaker-friend',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
